// extracted by mini-css-extract-plugin
module.exports = {"cities":"_1c_31","city":"X8kzk","city_active":"DGIcR","spinner":"_7kgsQ"};